import React from "react";
import { Typography } from "./ui/typography";
import CurrencyFormatter from "../utils/currencyFormatter";
import { Asset } from "../types/asset";
import { UserAutoStackResponse } from "../types/generated/api/types.gen";

interface MyStacksCardProps {
  stack: UserAutoStackResponse;
  asset?: Asset;
}

const MyStacksCard: React.FC<MyStacksCardProps> = ({ stack, asset }) => {
  const currencyFormatter = new CurrencyFormatter();

  const stackAsset = stack.asset as Asset;

  const formatAssetBalance = (balance: number, assetSymbol: string) => {
    if (balance === 0) return `0.0000000 ${assetSymbol.toUpperCase()}`;
    return currencyFormatter.formatCrypto(balance, assetSymbol.toUpperCase());
  };

  const formatFiatBalance = (balance: number) => {
    if (balance === 0) return "R0.00";
    return currencyFormatter.formatFiat(balance, "ZAR");
  };

  const assetDisplayName = asset?.assetName || stackAsset.asset.toUpperCase();
  const assetImage = asset?.image;
  const assetSymbol = stackAsset.asset.toUpperCase();

  return (
    <div className="bg-white border border-bg-section rounded-2xl p-3 hover:shadow-sm transition-shadow">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex flex-col gap-2">
            <Typography
              variant="h4"
              className="text-sm md:text-base font-semibold text-text-primary"
            >
              My {assetDisplayName} Vault
            </Typography>
            <div className="flex bg-gray-100 hover:bg-gray-50 rounded-full w-fit py-1 px-2 items-center gap-1">
              {assetImage && (
                <img
                  src={assetImage}
                  alt={assetDisplayName}
                  className="w-4 h-4 rounded-full object-cover"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              )}
              <Typography
                variant="caption"
                className="text-xs md:text-sm text-text-secondary"
              >
                {assetDisplayName}
              </Typography>
            </div>
          </div>
        </div>

        <div className="text-right">
          <Typography
            variant="p"
            className="text-xs md:text-sm font-semibold text-text-primary"
          >
            {formatAssetBalance(stack.asset_balance, assetSymbol)}
          </Typography>
          <Typography
            variant="caption"
            className="text-xs md:text-sm text-text-secondary block"
          >
            {formatFiatBalance(stack.fiat_balance || 0)}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default MyStacksCard;
